// Sprint-011 A6 (P6) — shared time-of-day greeting, replacing the two
// hardcoded "Good morning" literals (`app.tsx`'s phone app-bar,
// `DashboardView`'s desktop page-header) with one governed helper. Both
// call sites showed "Good morning" at any hour, including next to a
// weather card stamped with the real current time — a design-gate
// finding (P6). Boundaries follow the same everyday convention the rest
// of this app's copy uses (plain, no jargon): before noon is morning,
// noon through the end of the traditional workday is afternoon,
// otherwise evening.

/** [0, 12) morning · [12, 17) afternoon · [17, 24) evening. */
export function timeOfDayGreeting(now: Date = new Date()): string {
  const hour = now.getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}
